import { IJob } from '../job/IJob';
import { SearchExpression } from '../search/advanced/SearchExpression';

namespace app.model.batching {

  export class Batch implements IBatch {
    public prefix: string;
    public delimiter: string;
    public startValue: number;
    public zeroPaddingLength: number;
    public filesPerBatch: number;
    public keepFamiliesTogether = false;
    public job: IJob;
    public id: string;
    public projectId: string;
    public collections: string[];
    public filter;
    public searchExpression: SearchExpression;
    public columnFilters: SearchExpression;
    public query: String;
    public users: Array<String>;
    public roles: Array<String>;
    public resources: Array<string>;

    constructor(id: string = "", users: Array<String> = [], roles: Array<String> = []) {
      this.delimiter = "_";
      this.startValue = 1;
      this.zeroPaddingLength = 3;
      this.keepFamiliesTogether = true;
      this.filesPerBatch = 200;
      this.id = id;
      this.users = users;
      this.roles = roles;
    }
  }
}
